import { Text, Field, useSitecoreContext } from '@sitecore-jss/sitecore-jss-nextjs';
import classNames from 'classnames/bind';
import React from 'react';

import DynamicButton, { type DynamicButtonProps } from 'components/DynamicButtons/DynamicButton/DynamicButton';
import DynamicButtonBack from 'components/DynamicButtons/BackButton/DynamicButtonBack';
import { type contextType, DynamicButtonContext } from 'components/DynamicButtons/DynamicButtons';

import styles from './DynamicButtonSection.module.scss';

const cx = classNames.bind(styles);

export type DynamicButtonSectionProps = {
  choices: DynamicButtonProps[];
  id: string;
  parentId: string | null;
  title: Field<string>;
};

const DynamicButtonSection = React.forwardRef<HTMLHeadingElement, DynamicButtonSectionProps>(
  (props, ref): React.JSX.Element => {
    const { choices, id, parentId, title } = props;
    const { currentSection } = React.useContext(DynamicButtonContext) as contextType;
    const { sitecoreContext } = useSitecoreContext();

    const tagId = `dynamic-buttons__section--${id}`;

    return (
      <div
        id={tagId}
        className={cx('dynamic-buttons__section', { 'dynamic-buttons__section--visible': id === currentSection })}
        aria-hidden={id !== currentSection}
      >
        <h2 ref={ref} id={`dynamic-buttons__title--${id}`} tabIndex={0}>
          <Text field={title} encode={sitecoreContext.pageEditing} />
        </h2>
        {parentId !== null && choices?.length > 7 ? <DynamicButtonBack section={parentId} controls={tagId} /> : null}
        <ul>
          {choices?.map((choice: DynamicButtonProps, index: number) => {
            return <DynamicButton key={index} {...choice} />;
          })}
        </ul>
        {parentId !== null ? <DynamicButtonBack section={parentId} controls={tagId} /> : null}
      </div>
    );
  }
);

DynamicButtonSection.displayName = 'DynamicButtonSection';

export default DynamicButtonSection;
